import { render } from "./ThermageMigrationDrawer.vue?vue&type=template&id=d99f2d16&scoped=true"
import script from "./ThermageMigrationDrawer.vue?vue&type=script&lang=js"
export * from "./ThermageMigrationDrawer.vue?vue&type=script&lang=js"

import "./ThermageMigrationDrawer.vue?vue&type=style&index=0&id=d99f2d16&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d99f2d16"]])

export default __exports__